import { TimeZone } from '@core/typings/api/time-zone.typing';
import { BaseYcState, RegisterYCState } from '@yourcause/common/state';


@RegisterYCState()
export class TimeZoneState extends BaseYcState {
  readonly timeZones: TimeZone[];
}
